import { captureEvent } from '../utils/posthog';

/**
 * First-session analytics: one event to PostHog and, when gtag is loaded, to Google Analytics.
 * Properties never carry PII (no ids, emails or names), only step names and sources.
 */
export const track = (name, props = {}) => {
  captureEvent(name, props);
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, { event_category: 'Lab', ...props });
    }
  } catch (e) {
    // Analytics failures are not the user's problem
  }
};

export default track;
